import { render, staticRenderFns } from "./shopLoginConfig.vue?vue&type=template&id=66d023d4&scoped=true"
import script from "./shopLoginConfig.vue?vue&type=script&lang=js"
export * from "./shopLoginConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d023d4",
  null
  
)

export default component.exports